var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 116,
    viewBox: "0 0 118 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8377 28.3692L19.8377 28.3693L19.8448 28.3688C25.0943 28.0028 28.7618 30.4214 32.9583 33.5887C39.3878 38.481 46.6246 42.7291 54.5263 44.9218C62.566 47.1611 71.1338 47.5 79.52 47.5H79.5254C82.3799 47.5 85.227 47.5 88.0361 47.3798C89.948 47.3388 92.0094 47.1008 94.1077 46.8481C94.2401 46.8322 94.3727 46.8162 94.5054 46.8002C96.4864 46.561 98.4992 46.3181 100.488 46.2131C104.734 45.9888 108.765 46.4021 111.976 48.7471C114.475 50.7516 116.158 53.5991 116.707 56.7558L116.709 56.7645L116.711 56.7731C117.865 62.2467 117.797 69.0585 116.257 75.3893C114.715 81.7252 111.714 87.5151 107.059 91.0206C101.966 94.8553 95.6215 96.4669 89.0235 96.8835C82.4259 97.3 75.6163 96.5193 69.6254 95.6057C55.9582 93.5107 42.3625 89.9423 29.9935 83.7627L29.9931 83.7625C24.6264 81.0867 18.8095 77.7019 13.8213 73.5194C8.83147 69.3356 4.69677 64.3754 2.65181 58.5545C1.28733 54.6587 0.351388 49.9534 0.605442 45.4909C0.859289 41.032 2.29631 36.8636 5.62439 33.9505C9.6415 30.6149 14.6241 28.6583 19.8377 28.3692Z",
    fill: "#E6F2CC",
    stroke: "#E6F2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.03 115.56C79.3044 115.56 95.74 114.535 95.74 113.27C95.74 112.005 79.3044 110.98 59.03 110.98C38.7556 110.98 22.32 112.005 22.32 113.27C22.32 114.535 38.7556 115.56 59.03 115.56Z",
    fill: "#E6F2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.84 2.18C78.3812 2.18 78.82 1.74124 78.82 1.2C78.82 0.658764 78.3812 0.220001 77.84 0.220001C77.2988 0.220001 76.86 0.658764 76.86 1.2C76.86 1.74124 77.2988 2.18 77.84 2.18Z",
    fill: "#E6F2CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.05 97.29C33.5912 97.29 34.03 96.8513 34.03 96.31C34.03 95.7688 33.5912 95.33 33.05 95.33C32.5088 95.33 32.07 95.7688 32.07 96.31C32.07 96.8513 32.5088 97.29 33.05 97.29Z",
    fill: "#E6F2CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.39 102.3V106.6",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.23 104.45H91.54",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45 5.88C46.8413 5.88 36.6672 10.0943 29.1657 17.5957C21.6643 25.0972 17.45 35.2713 17.45 45.88C17.45 75.24 57.45 102.73 57.45 102.73C57.45 102.73 97.45 75.66 97.45 45.88C97.45 35.2713 93.2357 25.0972 85.7343 17.5957C78.2328 10.0943 68.0587 5.88 57.45 5.88ZM57.45 60.88C54.3347 60.88 51.2892 59.9567 48.6984 58.2267C46.1075 56.4968 44.0875 54.0377 42.8935 51.1603C41.6995 48.2829 41.3851 45.1161 41.99 42.0601C42.5948 39.004 44.0919 36.1958 46.2919 33.9901C48.492 31.7845 51.2964 30.2803 54.3509 29.6677C57.4054 29.0551 60.573 29.3615 63.4534 30.5482C66.3339 31.7349 68.798 33.7487 70.5345 36.3351C72.2711 38.9216 73.2021 41.9647 73.21 45.08C73.2074 49.259 71.5461 53.2661 68.5911 56.2211C65.6361 59.1761 61.629 60.8374 57.45 60.84V60.88Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 13.29V17.59",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 15.44H17.28",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.65 24.99V29.29",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.49 27.14H106.8",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.76 39.23L52.14 49.86",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.14 39.23L62.76 49.86",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholder);
export default __webpack_public_path__ + "static/media/location-placeholder.e10c2d4e62ee9bd09cb86d74d3182937.svg";
export { ForwardRef as ReactComponent };